//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import React           from 'react';
import ComponentHelper from '@/helper/ComponentHelper';
import IconType        from '@/components/stateless/atomic/Icon/IconType';
import PropTypes       from '@/components/PropTypes';
import { IconButton }  from '@/components/stateless/atomic/IconButton';
import styles          from './styles.module.scss';

export class Component extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            nextProps,
            nextState,
        );
    }

    render() {
        return (
            <h3 className={styles.formHeadline}>
                {this.props.text}
                {this.renderAddButton()}
            </h3>
        );
    }

    renderAddButton = () => {
        if (this.props.onClick) {
            return (
                <IconButton
                    iconType={IconType.addCircle}
                    onClick={this.props.onClick}
                />
            );
        }

        return null;
    };
}

export const FormHeadline = Component;

Component.propTypes = {
    onClick: PropTypes.func,
    text:    PropTypes.string.isRequired,
};

Component.defaultProps = {
    onClick: null,
    text:    '',
};

Component.renderAffectingProps = Object.keys(Component.defaultProps);

Component.renderAffectingStates = [];

export default Component;
